import { FormSearchField } from "@pharmupp/p3-front-commons"
import { userExternSpecificationReferential } from "../../../../../../referential"
import { fields } from "../../GeneralInfos.fields"
import { isExternSpecRequired } from "../../GeneralInfos.rg"
import { useGetUserTypeField } from "../useGetUserTypeField"

export const ConditionalExternSpecification = () => {
  const type = useGetUserTypeField()

  if (!isExternSpecRequired(type)) {
    return null
  }

  return (
    <FormSearchField
      label="Spécification de l'externe"
      name={fields.externSpecification}
      options={userExternSpecificationReferential}
      valueFormat="optionValue"
      required
    />
  )
}
